// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/menu/MessageNoti.css
// module id = 2010
// module chunks = 0